export default "__VITE_ASSET__DDi1VA2O__"